module.exports = __webpack_public_path__ + "img/strap width.db08972e.png";